import React, { useContext } from 'react';
import { Sacola } from '../Sacola';
import './styles.css';
import { ProdutosCategoria } from '../ProdutosCategoria';
import { Shimmer } from '../Shimmer';
import useWindowDimensions from '../../utils/utils';
import { GlobalContext } from '../../contexts/HomeContext';

export const ListaProdutos = React.memo(function ListaProdutos() {
  //export const ListaProdutos = () => {
  const { dadosApp } = useContext(GlobalContext);
  const { width } = useWindowDimensions();

  return (
    <>
      <div className="container margin_detail">
        <div className="row">
          <div className={`${dadosApp.Qs.cardapioDigital === 'true' ? 'col-lg-6' : 'col-lg-8'}`}>
            {dadosApp.Cardapio.Categorias.length == 0 ? <Shimmer type="Produtos" /> : ''}
            {dadosApp.Cardapio.Categorias.sort((ordem) => ordem.ordem_app).map((categoria, index) => {
              const _categoria =
                categoria.categoria_ecommerce === '' ? categoria.subgrupo : categoria.categoria_ecommerce;

              const _productList = dadosApp.Cardapio.Produtos?.filter((produto) => {
                if (categoria.categoria_ecommerce !== '') {
                  return (
                    produto.categoria_ecommerce === categoria.categoria_ecommerce && // ERRADO ??????????
                    produto.is_subitem_multpreco === false // regra para os multi preços
                  );
                } else {
                  return produto.subgrupo === categoria.subgrupo && produto.is_subitem_multpreco === false; // regra para os multi preços
                }
              });

              // correção de categorias sem produtos
              if (_productList?.length > 0) {
                return (
                  <section key={_categoria} id={_categoria?.toUpperCase()} className="page-section">
                    <ProdutosCategoria key={index} categoria={categoria} produtos={_productList} />
                  </section>
                );
              }
            })}
          </div>

          {width > 991 && dadosApp.Cardapio.Categorias.length > 0 && dadosApp.Qs.cardapioDigital !== 'true' && (
            <Sacola
              param={{
                origin: 'desktop',
              }}
            />
          )}
        </div>
      </div>
    </>
  );
});
